module.exports = __webpack_public_path__ + "img/switch.d4559b1d.svg";